import { NotificationT } from 'lib-shared-legacy-types';
import { useNavigate } from 'react-router-dom';
import { useMount } from 'react-use';

type RatingNotificationProps = {
  notification: NotificationT;
  dispatch: (payload: any) => void;
  notificationRemoveById: (payload: { id: string }) => void;
};

const RatingNotification = (props: RatingNotificationProps): JSX.Element => {
  const navigate = useNavigate();

  useMount(() => {
    window.setTimeout(() => {
      props.notificationRemoveById({ id: props.notification.id });
    }, props.notification.startTime as number);
  });

  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    if (
      props.notification.mainAction &&
      typeof props.notification.mainAction === 'function'
    ) {
      const action = props.notification.mainAction();
      if (action !== undefined) {
        nextAndExecute(action);
      }
    } else if (
      props.notification.mainAction &&
      typeof props.notification.mainAction === 'object' &&
      props.notification.mainAction.navigate
    ) {
      navigate(props.notification.mainAction.navigate);
    } else {
      e.preventDefault();
      return;
    }
  };

  const nextAndExecute = (action: any) => {
    const next = action.next();
    if (next.value) {
      const nextCopy = Object.assign({}, next);
      props.dispatch(nextCopy.value.PUT.action);
      nextAndExecute(action);
    }
  };

  return (
    <div
      className={`alert alert-rating ${
        props.notification.type === 'rating-up'
          ? 'alert-success'
          : 'alert-danger'
      }`}
      onClick={handleClick}
    >
      <div>
        <span
          className={
            props.notification.type === 'rating-down'
              ? 'i-thumbs-down'
              : 'i-thumbs-up'
          }
        ></span>
      </div>
    </div>
  );
};

export default RatingNotification;
